export default 'https://tme.understood.org/assets/player.83605428.glb'